import styled from 'styled-components';

export const ContainerChart = styled.div`
  display: flex;
  flex-direction: row;
  gap: 5px;
  flex-wrap: wrap;
`;

export const LegendChart = styled.div`
  display: inline-flex;
  padding: 20px;
  border: 1px solid #636363;
  margin-top: 20px;
  margin-left: 2px;
  max-height: 290px;
  width: fit-content;
  max-width: 100%;
`;

export const LegendChartContent = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 18px;
`;
